var map = {
  "./cs.json": [
    "Xbn",
    [
      "ds"
    ]
  ],
  "./en.json": [
    "ol1",
    [
      "y8"
    ]
  ],
  "./pl.json": [
    "Yi",
    [
      "2c"
    ]
  ],
  "./ru.json": [
    "E8",
    [
      "il0"
    ]
  ],
  "./tr.json": [
    "aR",
    [
      "0f9"
    ]
  ],
  "./ja.json": [
    "xae",
    [
      "brz"
    ]
  ],
  "./zh.json": [
    "JU",
    [
      "vb"
    ]
  ],
  "./pt-br.json": [
    "gZ",
    [
      61
    ]
  ],
  "./de.json": [
    "PZ",
    [
      "lo7"
    ]
  ],
  "./es.json": [
    "VG",
    [
      74
    ]
  ],
  "./fr.json": [
    "y77",
    [
      "8t"
    ]
  ],
  "./it.json": [
    "SbN",
    [
      "o4"
    ]
  ],
  "./ko.json": [
    "gqc",
    [
      "yd"
    ]
  ],
  "./pt.json": [
    "zf",
    [
      "5u8"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "kt";
module.exports = __rspack_async_context;
